import React from 'react';
import PriceAlertItem from './PriceAlertItem';
import { PriceAlert } from '../types';
import { DateFormat } from '@/services/enums';

interface PriceAlertsListProps {
  alerts: PriceAlert[];
  onAlertClick?: (alert: PriceAlert) => void;
  onAlertLongPress?: (alert: PriceAlert) => void;
  isAlertWatched?: (alert: PriceAlert) => boolean;
  className?: string;
  timeFormat?: DateFormat;
}

const PriceAlertsList: React.FC<PriceAlertsListProps> = ({
  alerts,
  onAlertClick,
  onAlertLongPress,
  isAlertWatched,
  className = '',
  timeFormat = 'history',
}) => {
  return (
    <div className={`space-y-3 pt-3 ${className}`}>
      {alerts.map((alert) => (
        <PriceAlertItem
          key={alert.id}
          alert={alert}
 onClick={() => onAlertClick?.(alert)}
                onLongPress={() => onAlertLongPress?.(alert)}
                isWatched={isAlertWatched?.(alert)}
                timeFormat={timeFormat}
              />))}
    </div>
  );
};

export default PriceAlertsList;
